/* Helper for uploading photos & videos to Emergent Object Storage via our backend. */
import api from "./api";

/**
 * Upload a single image file. Returns the public URL (string) you can put in an <img src>.
 * Throws on failure with a user-friendly Error message.
 */
export async function uploadImage(file, opts = {}) {
  if (!file) throw new Error("No file selected");
  if (file.size > 8 * 1024 * 1024) {
    throw new Error("Image must be under 8 MB");
  }
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: opts.onProgress,
  });
  return data.url;
}

/** Upload a portfolio video. Returns the URL string. */
export async function uploadVideo(file, opts = {}) {
  if (!file) throw new Error("No file selected");
  if (file.size > 50 * 1024 * 1024) {
    throw new Error("Video must be under 50 MB");
  }
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/video", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: opts.onProgress,
  });
  return data.url;
}

/** Upload many files in parallel (images). Returns array of URLs in order. */
export async function uploadImages(files) {
  return Promise.all(Array.from(files).map((f) => uploadImage(f)));
}

/**
 * Given a stored URL like "/api/files/myhandyhub/images/.../foo.png" returns the
 * fully-qualified URL the browser can actually request. Plain external URLs pass through.
 */
export function fullUrl(urlOrPath) {
  if (!urlOrPath) return urlOrPath;
  if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://") || urlOrPath.startsWith("data:")) {
    return urlOrPath;
  }
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return urlOrPath.startsWith("/") ? `${base}${urlOrPath}` : `${base}/${urlOrPath}`;
}
